export const PANEL_TRANSLATIONS: { [key: string]: string } = {
  'amount.title': $localize `:@@layout.panel.amount.title:`,
  'amount.description': $localize `:@@layout.panel.amount.description:`,
  'coupons.title': $localize `:@@layout.panel.coupons.title:`,
  'coupons.description': $localize `:@@layout.panel.coupons.description:`,
  'address.title': $localize `:@@layout.panel.address.title:`,
  'address.description': $localize `:@@layout.panel.address.description:`,
  'payment.title': $localize `:@@layout.panel.payment.title:`,
  'payment.description': $localize `:@@layout.panel.payment.description:`,
  'choose_payment.title': $localize `:@@layout.panel.choose_payment.title:`,
  'choose_payment.description': $localize `:@@layout.panel.choose_payment.description:`,
  'shipping.title': $localize `:@@layout.panel.shipping.title:`,
  'shipping.description': $localize `:@@layout.panel.shipping.description:`,
  'express_choose_payment.title': $localize `:@@layout.panel.express_choose_payment.title:`,
  'express_choose_payment.description': $localize `:@@layout.panel.express_choose_payment.description:`,
  'expressChoosePayment.title': $localize `:@@layout.panel.express_choose_payment.title:`,
  'expressChoosePayment.description': $localize `:@@layout.panel.express_choose_payment.description:`,
  'express_payment.title': $localize `:@@layout.panel.express_payment.title:`,
  'express_payment.description': $localize `:@@layout.panel.express_payment.description:`,
  'expressPayment.title': $localize `:@@layout.panel.express_payment.title:`,
  'expressPayment.description': $localize `:@@layout.panel.express_payment.description:`,
  'payment_no_choose.title': $localize `:@@layout.panel.payment_no_choose.title:`,
  'payment_no_choose.description': $localize `:@@layout.panel.payment_no_choose.description:`,
  'send_to_device.title': $localize `:@@layout.panel.send_to_device.title:`,
  'send_to_device.description': $localize `:@@layout.panel.send_to_device.description:`,
  'qr.title': $localize `:@@layout.panel.qr.title:`,
  'qr.description': $localize `:@@layout.panel.qr.description:`,
  'order.title': $localize `:@@layout.panel.order.title:`,
  'order.description': $localize `:@@layout.panel.order.description:`,
  'choosePayment.title': $localize `:@@layout.panel.choosePayment.title:`,
  'choosePayment.description': $localize `:@@layout.panel.choosePayment.description:`,
  'editPayment.title': $localize `:@@layout.panel.editPayment.title:`,
  'editPayment.description': $localize `:@@layout.panel.editPayment.description:`,
  'user.title': $localize `:@@layout.panel.user.title:`,
  'user.description': $localize `:@@layout.panel.user.description:`,
};
